
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'
import PartsLayout from '../../common/parts/PartsLayout.vue'
import { LayoutConfig, Parts } from '../../common/parts/types'

/**
 * 웹파트 추가/편집 모달
 * 웹파트의 상세 설정을 수정할 수 있다.
 */
@Component<DesignPreviewModal>({
    name: 'DesignPreviewModal',
    components: { ModalLayout, PartsLayout },
})
export default class DesignPreviewModal extends Vue {
    @Prop({ type: Object }) layout!: LayoutConfig
    @Prop({ type: Array }) parts!: Parts

    get modalSize() {
        const { designWidth, rowHeight, cols, rows } = this.layout
        const width = designWidth
        const height = rowHeight * rows
        return `width:${width}px;  padding: 0;`
    }

    handleCloseModal() {
        this.closeCurrentModal()
    }
}
